<template>
    <div class="rose-page">
        <!-- 飘落的花瓣 -->
        <div class="petals" aria-hidden="true">
            <span class="petal" v-for="(p, i) in petals" :key="i" :style="p.style"></span>
        </div>

        <!-- 主卡片 -->
        <div class="rose-card" :class="{ burst: burst }">
            <!-- 红玫瑰 -->
            <div class="rose-wrap" :class="{ burst: burst }" @click="bloom">
                <svg class="rose-svg" viewBox="0 0 200 200">
                    <defs>
                        <radialGradient id="roseGrad" cx="50%" cy="38%" r="70%">
                            <stop offset="0%" stop-color="#ff8494" />
                            <stop offset="55%" stop-color="#cf1f3d" />
                            <stop offset="100%" stop-color="#7d0f22" />
                        </radialGradient>
                        <radialGradient id="roseCore" cx="50%" cy="45%" r="60%">
                            <stop offset="0%" stop-color="#ff9aa8" />
                            <stop offset="100%" stop-color="#96122b" />
                        </radialGradient>
                    </defs>
                    <g class="petals-layer">
                        <ellipse v-for="a in 8" :key="'o' + a" cx="100" cy="72" rx="33" ry="45" fill="url(#roseGrad)" :transform="'rotate(' + (a - 1) * 45 + ' 100 100)'" opacity="0.95" />
                    </g>
                    <g class="petals-inner">
                        <ellipse v-for="a in 6" :key="'i' + a" cx="100" cy="84" rx="24" ry="32" fill="#b81734" :transform="'rotate(' + ((a - 1) * 60 + 30) + ' 100 100)'" />
                    </g>
                    <circle cx="100" cy="100" r="24" fill="url(#roseCore)" />
                    <path d="M100 82c13 5 19 20 10 29-7 8-20 5-22-6-2-9 7-15 14-11" fill="none" stroke="#ffb3bf" stroke-width="3.5" stroke-linecap="round" />
                </svg>
                <!-- 点击绽放：中心闪光 + 冲击光环 -->
                <span class="burst-flash"></span>
                <span class="burst-ring" v-for="r in 2" :key="'r' + r" :style="{ animationDelay: (r - 1) * 0.12 + 's' }"></span>
                <!-- 花瓣沿各自角度飞散 -->
                <span class="burst-arm" v-for="(p, i) in burstPetals" :key="'p' + i" :style="{ transform: 'rotate(' + p.a + 'deg)' }">
                    <i class="burst-petal" :class="'fly-' + p.tier" :style="p.style"></i>
                </span>
                <!-- 飘起的心与星 -->
                <span class="burst-spark" v-for="(s, i) in burstSparks" :key="'sp' + i" :style="s.style">{{ s.ch }}</span>
            </div>

            <!-- 署名标题 -->
            <div class="name-block">
                <div class="name-cn">小 张 玲</div>
                <div class="name-line">入目无他人 · 四下皆是你</div>
            </div>

            <!-- 诗句 -->
            <div class="verse-block">
                <p class="verse-line" v-for="(v, i) in verses" :key="'v' + i" :style="{ animationDelay: 0.1 + i * 0.32 + 's' }">{{ v }}</p>
            </div>

            <!-- 正文 -->
            <div class="letter-body">
                <p class="letter-p" v-for="(p, i) in paragraphs" :key="i" :style="{ animationDelay: 0.2 + i * 0.15 + 's' }">{{ p }}</p>
            </div>

            <!-- 三朵小玫瑰 -->
            <div class="rose-row">
                <svg class="rose-mini" viewBox="0 0 200 200" v-for="n in 3" :key="'m' + n">
                    <circle cx="100" cy="100" r="70" fill="#a5122c" opacity="0.25" />
                    <ellipse v-for="a in 6" :key="'mo' + a" cx="100" cy="80" rx="26" ry="36" fill="url(#roseGrad)" :transform="'rotate(' + (a - 1) * 60 + ' 100 100)'" />
                    <circle cx="100" cy="100" r="22" fill="url(#roseCore)" />
                </svg>
            </div>

            <!-- 落款 -->
            <footer class="letter-sign">
                <span class="sign-name">—— 那个会一直陪着你的人</span>
                <span class="sign-date">2026年9月29日</span>
            </footer>
        </div>

        <!-- 下注脚 -->
        <div class="rose-foot">
            <span class="foot-heart" @click="bloom">❤</span>
            <span>点一下玫瑰，它替你红一次</span>
        </div>

        <div class="letter-back" @click="goBack"><span class="back-ico">‹</span> 返回列表</div>
    </div>
</template>

<script>
export default {
    name: 'RoseToZhangLing',
    data() {
        return {
            burst: false,
            petals: [],
            burstPetals: [],
            burstSparks: [],
            verses: ['只愿君心似我心，定不负相思意。', '愿我如星君如月，夜夜流光相皎洁。'],
            verseFrom: '集句 · 李之仪《卜算子》／范成大《车遥遥篇》',
            paragraphs: [
                '舍不得的，原来都是很小的东西——你生气时仍忍不住上扬的嘴角，随口那句「我知道了」「你早点睡」。我一直收着，不给谁看。有些话不必说出口，我只是，一直没舍得。',
                '我更心疼。心疼你一个人扛着那些从没跟我说过的事，心疼你难受的时候还在反过来安慰别人，心疼你明明已经很累了，还要笑着说「没事」。如果可以，我想把那些累都搬到我这边来。',
                '我知道我做得不够好，让你受了委屈。也知道「对不起」三个字很轻，轻到配不上你失望的眼神。我不辩解，只想把该改的，一样一样改给你看——不用你催，也不用你等太久。',
                '我不想用情绪绑住你，所以不说什么「求你留下」。我只想让你知道：我在这儿。等一下也行，等很久也行。你要往前走，我不拦你；你哪天回头，我一定还在。'
            ]
        }
    },
    mounted() {
        this.petals = this.makePetals(16)
        this.burstPetals = this.makeBurstPetals(26)
        this.burstSparks = this.makeBurstSparks()
        // 进页面先自己红一次
        this.autoTimer = setTimeout(() => {
            this.bloom()
        }, 700)
    },
    beforeDestroy() {
        clearTimeout(this.autoTimer)
        clearTimeout(this.burstTimer)
    },
    methods: {
        makePetals(n) {
            const arr = []
            for (let i = 0; i < n; i++) {
                const size = 12 + Math.random() * 14
                arr.push({
                    style: {
                        left: Math.random() * 96 + '%',
                        width: size + 'px',
                        height: size * 1.3 + 'px',
                        animationDuration: 6 + Math.random() * 7 + 's',
                        animationDelay: -Math.random() * 13 + 's',
                        opacity: 0.65 + Math.random() * 0.3
                    }
                })
            }
            return arr
        },
        // 26 片花瓣：角度均匀铺开，距离分近/中/远三档，时长与延迟抖动
        makeBurstPetals(n) {
            const tiers = ['near', 'mid', 'far']
            const arr = []
            for (let i = 0; i < n; i++) {
                const size = 10 + Math.random() * 13
                arr.push({
                    a: Math.round((360 / n) * i + (Math.random() * 12 - 6)),
                    tier: tiers[i % 3],
                    style: {
                        width: size + 'px',
                        height: size * 1.32 + 'px',
                        marginLeft: -(size / 2) + 'px',
                        marginTop: -(size * 0.66) + 'px',
                        animationDuration: 0.85 + Math.random() * 0.5 + 's',
                        animationDelay: Math.random() * 0.09 + 's'
                    }
                })
            }
            return arr
        },
        // 飘起的心与星：横向随机散开，向上飘散渐隐
        makeBurstSparks() {
            const chars = ['❤', '✦', '❤', '✧', '❤', '✦', '♡', '✧', '❤', '✦']
            const arr = []
            for (let i = 0; i < chars.length; i++) {
                arr.push({
                    ch: chars[i],
                    style: {
                        left: 18 + Math.random() * 64 + '%',
                        fontSize: 12 + Math.random() * 11 + 'px',
                        color: i % 3 === 0 ? '#ffe0e7' : '#ff6b85',
                        animationDuration: 1 + Math.random() * 0.55 + 's',
                        animationDelay: 0.04 + Math.random() * 0.2 + 's'
                    }
                })
            }
            return arr
        },        bloom() {
            clearTimeout(this.burstTimer)
            this.burst = false
            this.$nextTick(() => {
                this.burst = true
                this.burstTimer = setTimeout(() => {
                    this.burst = false
                }, 1700)
            })
        },
        goBack() {
            if (window.history.length > 1) {
                this.$router.back()
            } else {
                this.$router.push('/forzl')
            }
        }
    }
}
</script>

<style lang="less" scoped>
.rose-page {
    position: relative;
    min-height: 100vh;
    box-sizing: border-box;
    padding: 46px 30px 60px;
    background: radial-gradient(120% 80% at 50% 0%, #6b0f21 0%, #4a0a17 45%, #2b040c 100%);
    overflow: hidden;
}

/* ---------- 飘落花瓣 ---------- */
.petals {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    pointer-events: none;
    z-index: 9; /* 浮在卡片之上，花瓣从眼前飘落 */
}
.petal {
    position: absolute;
    top: -6%;
    display: block;
    background: linear-gradient(140deg, #ffb3c0 0%, #ef3b5c 45%, #b2162f 100%);
    box-shadow: 0 0 8px rgba(255, 110, 135, 0.55);
    border-radius: 50% 0 50% 50%;
    will-change: top, transform, opacity;
    animation-name: petalFall;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
}
@keyframes petalFall {
    0% {
        top: -6%;
        transform: translateX(0) rotate(0deg);
    }
    45% {
        transform: translateX(26px) rotate(170deg);
    }
    100% {
        top: 106%;
        transform: translateX(-20px) rotate(360deg);
    }
}

/* ---------- 主卡片 ---------- */
.rose-card {
    position: relative;
    z-index: 1;
    max-width: 640px;
    margin: 0 auto;
    background: linear-gradient(180deg, rgba(255, 252, 250, 0.97) 0%, rgba(255, 244, 243, 0.95) 100%);
    border: 1px solid rgba(207, 31, 61, 0.25);
    border-radius: 20px;
    box-shadow: 0 14px 44px rgba(0, 0, 0, 0.45), inset 0 0 0 6px rgba(255, 255, 255, 0.5);
    padding: 44px 36px 38px;
    transition: box-shadow 0.5s ease, border-color 0.5s ease;
}
/* 绽放时整张卡片跟着亮一下 */
.rose-card.burst {
    border-color: rgba(255, 80, 110, 0.55);
    box-shadow: 0 0 0 1px rgba(255, 80, 110, 0.35), 0 0 58px rgba(255, 60, 100, 0.42), 0 14px 44px rgba(0, 0, 0, 0.45),
        inset 0 0 0 6px rgba(255, 255, 255, 0.55);
}

/* ---------- 玫瑰 ---------- */
.rose-wrap {
    position: relative;
    width: 180px;
    height: 180px;
    margin: 0 auto 22px;
    cursor: pointer;
}
.rose-svg {
    width: 100%;
    height: 100%;
    filter: drop-shadow(0 8px 18px rgba(150, 10, 35, 0.35));
    animation: roseBreath 3.6s ease-in-out infinite;
    transition: filter 0.35s ease;
}
@keyframes roseBreath {
    0%,
    100% {
        transform: scale(1) rotate(0deg);
    }
    50% {
        transform: scale(1.05) rotate(2deg);
    }
}
.rose-wrap.burst .rose-svg {
    animation: roseBurst 0.9s ease-out;
    filter: drop-shadow(0 0 30px rgba(255, 90, 120, 0.95));
}
@keyframes roseBurst {
    0% {
        transform: scale(1);
    }
    40% {
        transform: scale(1.16) rotate(-4deg);
    }
    100% {
        transform: scale(1) rotate(0deg);
    }
}
/* ---------- 点击绽放 ---------- */
/* 中心闪光 */
.burst-flash {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 170px;
    height: 170px;
    margin: -85px 0 0 -85px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.95) 0%, rgba(255, 140, 165, 0.7) 34%, rgba(255, 80, 110, 0) 70%);
    opacity: 0;
    pointer-events: none;
}
.rose-wrap.burst .burst-flash {
    animation: flashPop 0.7s ease-out forwards;
}
@keyframes flashPop {
    0% {
        opacity: 0;
        transform: scale(0.2);
    }
    25% {
        opacity: 0.95;
    }
    100% {
        opacity: 0;
        transform: scale(1.5);
    }
}

/* 冲击光环（两圈错时扩散） */
.burst-ring {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 96px;
    height: 96px;
    margin: -48px 0 0 -48px;
    border: 2px solid rgba(255, 214, 222, 0.8);
    border-radius: 50%;
    box-shadow: 0 0 22px rgba(255, 90, 120, 0.55), inset 0 0 14px rgba(255, 120, 145, 0.5);
    opacity: 0;
    pointer-events: none;
}
.rose-wrap.burst .burst-ring {
    animation: ringOut 1.05s cubic-bezier(0.2, 0.7, 0.3, 1) forwards;
}
@keyframes ringOut {
    0% {
        opacity: 0.9;
        transform: scale(0.35);
    }
    70% {
        opacity: 0.3;
    }
    100% {
        opacity: 0;
        transform: scale(2.5);
    }
}

/* 花瓣爆开：外层承载角度，内层负责飞出与自旋 */
.burst-arm {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    pointer-events: none;
}
.burst-petal {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    background: linear-gradient(140deg, #ffc9d4 0%, #f0425f 45%, #a8122c 100%);
    box-shadow: 0 0 9px rgba(255, 110, 140, 0.8);
    border-radius: 50% 0 50% 50%;
    opacity: 0;
}
.rose-wrap.burst .burst-petal {
    animation-timing-function: cubic-bezier(0.16, 0.72, 0.3, 1);
    animation-fill-mode: forwards;
}
.rose-wrap.burst .fly-near {
    animation-name: flyNear;
}
.rose-wrap.burst .fly-mid {
    animation-name: flyMid;
}
.rose-wrap.burst .fly-far {
    animation-name: flyFar;
}
@keyframes flyNear {
    0% {
        opacity: 0;
        transform: translateY(-10px) rotate(0deg) scale(0.5);
    }
    18% {
        opacity: 1;
    }
    100% {
        opacity: 0;
        transform: translateY(-78px) rotate(200deg) scale(1.08);
    }
}
@keyframes flyMid {
    0% {
        opacity: 0;
        transform: translateY(-14px) rotate(0deg) scale(0.45);
    }
    18% {
        opacity: 1;
    }
    100% {
        opacity: 0;
        transform: translateY(-134px) rotate(340deg) scale(0.9);
    }
}
@keyframes flyFar {
    0% {
        opacity: 0;
        transform: translateY(-18px) rotate(0deg) scale(0.4);
    }
    18% {
        opacity: 1;
    }
    100% {
        opacity: 0;
        transform: translateY(-196px) rotate(480deg) scale(0.72);
    }
}

/* 飘起的心与星 */
.burst-spark {
    position: absolute;
    bottom: 42%;
    line-height: 1;
    opacity: 0;
    pointer-events: none;
    text-shadow: 0 0 9px rgba(255, 90, 120, 0.75);
}
.rose-wrap.burst .burst-spark {
    animation-name: sparkUp;
    animation-timing-function: ease-out;
    animation-fill-mode: forwards;
}
@keyframes sparkUp {
    0% {
        opacity: 0;
        transform: translateY(0) translateX(0) scale(0.4);
    }
    22% {
        opacity: 1;
        transform: translateY(-18px) translateX(6px) scale(1.15);
    }
    100% {
        opacity: 0;
        transform: translateY(-110px) translateX(14px) scale(0.8);
    }
}

/* ---------- 名字 ---------- */
.name-block {
    text-align: center;
    margin-bottom: 34px;
    .name-cn {
        font-size: 52px;
        font-weight: 600;
        color: #9c1030;
        letter-spacing: 14px;
        text-indent: 14px;
        font-family: 'STKaiti', 'KaiTi', '楷体', serif;
    }
    .name-line {
        margin-top: 14px;
        font-size: 26px;
        color: #c2566e;
        letter-spacing: 2px;
    }
}

/* ---------- 诗句 ---------- */
.verse-block {
    text-align: center;
    margin-bottom: 34px;
    padding-bottom: 26px;
    border-bottom: 1px dashed rgba(207, 31, 61, 0.28);
}
.verse-line {
    margin: 0 0 12px;
    font-family: 'STKaiti', 'KaiTi', '楷体', serif;
    font-size: 30px;
    line-height: 1.9;
    color: #8c1430;
    letter-spacing: 3px;
    text-indent: 3px;
    white-space: nowrap;
    opacity: 0;
    animation: pIn 0.8s ease forwards;
    &:last-child {
        margin-bottom: 0;
    }
}
.verse-from {
    margin-top: 16px;
    font-size: 20px;
    color: #c5949f;
    letter-spacing: 1px;
    opacity: 0.9;
}

/* ---------- 正文 ---------- */
.letter-body {
    margin-top: 6px;
}
.letter-p {
    margin: 0 0 26px;
    font-size: 30px;
    line-height: 1.9;
    color: #4a3a3c;
    text-align: justify;
    text-indent: 2em;
    word-break: break-all;
    opacity: 0;
    animation: pIn 0.7s ease forwards;
}
@keyframes pIn {
    from {
        opacity: 0;
        transform: translateY(14px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* ---------- 小玫瑰 ---------- */
.rose-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin: 34px 0 26px;
    .rose-mini {
        width: 62px;
        height: 62px;
        animation: roseBreath 3.6s ease-in-out infinite;
        &:nth-child(2) {
            animation-delay: 0.5s;
        }
        &:nth-child(3) {
            animation-delay: 1s;
        }
    }
}

/* ---------- 落款 ---------- */
.letter-sign {
    text-align: right;
    border-top: 1px solid rgba(207, 31, 61, 0.18);
    padding-top: 24px;
    .sign-name {
        display: block;
        font-family: 'STKaiti', 'KaiTi', '楷体', serif;
        font-size: 30px;
        color: #9c1030;
    }
    .sign-date {
        display: block;
        margin-top: 10px;
        font-size: 24px;
        color: #b58690;
    }
}

/* ---------- 脚注 ---------- */
.rose-foot {
    position: relative;
    z-index: 1;
    max-width: 640px;
    margin: 26px auto 0;
    text-align: center;
    font-size: 24px;
    color: #e79aa8;
    .foot-heart {
        color: #ff5570;
        font-size: 30px;
        margin-right: 10px;
        vertical-align: -2px;
        animation: heartBeat 1.6s ease-in-out infinite;
    }
}
@keyframes heartBeat {
    0%,
    100% {
        transform: scale(1);
    }
    30% {
        transform: scale(1.22);
    }
    60% {
        transform: scale(1);
    }
}

.letter-back {
    position: relative;
    z-index: 1;
    max-width: 640px;
    margin: 24px auto 0;
    text-align: center;
    font-size: 28px;
    color: #f0b9c3;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.28);
    border-radius: 999px;
    padding: 16px 0;
    .back-ico {
        font-size: 32px;
        margin-right: 8px;
        vertical-align: -2px;
    }
    &:active {
        background: rgba(255, 255, 255, 0.2);
    }
}
</style>
